// src/Login.js
import React, { useState } from "react";
import axios from "axios";

function Login({ onLogin }) {
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [showSenha, setShowSenha] = useState(false);
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setMensagem("");
    setLoading(true);
    try {
      // Cria uma conexão "limpa" para fugir do interceptador global que recarrega a página no 401
      const conexaoLimpa = axios.create({ baseURL: axios.defaults.baseURL });
      const res = await conexaoLimpa.post("/api/login", { usuario, senha, lembrar: remember });
      onLogin({ ...res.data, __remember: remember });
    } catch (err) {
      const msg = err?.response?.data?.error || "Usuário ou senha inválidos!";
      setMensagem(msg);
      // Garante que a mensagem fique visível por 5 segundos (5000ms) antes de limpar
      setTimeout(() => setMensagem(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 font-sans p-4">
      
      {/* Card Principal Centralizado */}
      <div className="flex flex-col md:flex-row w-full max-w-[900px] bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] overflow-hidden min-h-[550px]">
        
        {/* Lado Esquerdo (Apenas Logo - Desktop) - Fundo Branco */}
        <div className="hidden md:flex md:w-1/2 bg-white items-center justify-center p-12 border-r border-slate-100">
          <img 
            src="/logo-relatorio.png" 
            alt="Logo PoliUB" 
            className="w-full max-w-[280px] object-contain drop-shadow-sm hover:scale-105 transition-transform duration-500"
            onError={(e) => {
              e.target.onerror = null; 
              e.target.style.display = 'none'; 
            }}
          />
        </div>

        {/* Lado do Formulário (Direita) */}
        <div className="w-full md:w-1/2 p-8 md:p-12 flex flex-col justify-center">
          <form onSubmit={handleSubmit} className="w-full max-w-sm mx-auto space-y-8">
            
            {/* Cabeçalho do Form */}
            <div className="flex flex-col items-center text-center gap-2">
              {/* Logo exibido APENAS no mobile (oculto no desktop para não repetir) */}
              <img 
                src="/logo-relatorio.png" 
                alt="Logo PoliUB" 
                className="h-20 w-auto object-contain drop-shadow-sm md:hidden mb-2"
                onError={(e) => {
                  e.target.onerror = null; 
                  e.target.style.display = 'none';
                }}
              />
              <h2 className="text-2xl font-semibold text-slate-800 tracking-tight">Acesso ao Sistema</h2>
              <p className="text-sm text-slate-500">Insira suas credenciais para continuar</p>
            </div>

            <div className="space-y-5">
              <div className="relative">
                <label htmlFor="usuario" className="block text-sm font-medium text-slate-700 mb-1">
                  Usuário
                </label>
                <input
                  id="usuario"
                  name="username"
                  type="text"
                  placeholder="Digite seu usuário"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  required
                  autoComplete="username"
                  className="w-full bg-slate-50 border border-slate-200 text-slate-900 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white transition-colors"
                />
              </div>

              <div className="relative">
                <label htmlFor="senha" className="block text-sm font-medium text-slate-700 mb-1">
                  Senha
                </label>
                <input
                  id="senha"
                  name="password"
                  type={showSenha ? "text" : "password"}
                  placeholder="••••••••"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  required
                  autoComplete="current-password"
                  className="w-full bg-slate-50 border border-slate-200 text-slate-900 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white transition-colors pr-16"
                  aria-invalid={!!mensagem}
                />
                <button
                  type="button"
                  onClick={() => setShowSenha(!showSenha)}
                  className="absolute right-3 top-[34px] px-2 py-1 text-xs font-medium text-blue-600 hover:text-blue-800 bg-blue-50 rounded transition-colors"
                >
                  {showSenha ? 'Ocultar' : 'Mostrar'}
                </button>
              </div>

              <div className="flex items-center justify-between pt-1">
                <label className="flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900 cursor-pointer transition-colors">
                  <input 
                    type="checkbox" 
                    checked={remember} 
                    onChange={(e) => setRemember(e.target.checked)}
                    className="rounded border-slate-300 text-blue-600 focus:ring-blue-500 w-4 h-4 cursor-pointer"
                  />
                  Manter conectado
                </label>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-lg shadow-sm shadow-blue-600/20 transition-all ${loading ? 'opacity-70 cursor-wait' : 'hover:-translate-y-0.5'}`}
            >
              {loading ? 'Autenticando...' : 'Entrar no Sistema'}
            </button>

            {mensagem && (
              <div className="bg-red-50 text-red-600 text-sm text-center p-3 rounded-lg border border-red-100" role="alert" aria-live="polite">
                {mensagem}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;